import styled from "styled-components";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./components/tabs/tabs";
import { white } from "@habitech/shared";

export const Wrapper = styled.div`
    background: ${white};
    border-radius: 10px;
    padding: 0;
    margin-bottom: 40px;
    .retention-tabs {
        margin: 0;
    }
    .container {
        padding: 0px;
    }
    @media ${({ theme }) => theme.screenSizes.tablet} {
        padding: 24px 0px;
    }

    @media ${({ theme }) => theme.screenSizes.laptop} {
        margin: 0 auto;
        padding: 16px 24px;
    }
`;


export const BuilderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  
  @media (min-width: 1024px) {
    grid-template-columns: 2fr 1fr;
  }
`;

export const ControlsContainer = styled.div``;


export const StyledTabs = styled(Tabs)`
  width: 100%;
`;

export const StyledTabsList = styled(TabsList)`
  width: 100%;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  background-color: var(--accent);
  padding: 0.25rem;
`;

export const StyledTabsTrigger = styled(TabsTrigger)`
  flex: 1;
  font-weight: 500;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  &[data-state="active"] {
    background-color: white;
    color: var(--primary);
  }

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

export const StyledTabsContent = styled(TabsContent)`
  width: 100%;
`;

export const PreviewSidebar = styled.div`
  position: sticky;
  top: 2rem;
`;

export const WrapperH1 = styled.div`
  .notification {
    text-align: center;
  }
  button {
    float: right;
  }
`

export const PreviewSidebarContent = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: 1.5rem;
`;

export const PreviewTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

export const SelectedAudienceContainer = styled.div`
  margin-top: 1rem;
`;

export const UserTypeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background-color: #f3f4f6;
  border-radius: 9999px;
  padding: 0.25rem 0.75rem;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
`;

export const AudienceSummary = styled.div`
  margin-top: 1rem;
  font-size: 0.875rem;
  color: #4b5563;
  
  p {
    margin-bottom: 0.5rem;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;
`;

export const PageTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #00843D;
`;
